import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class UploadCacheInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes("importProcedureCSV")) {
      request = request.clone({
        headers: request.headers.append("Cache-Control", "no-cache"),
      });
      return next.handle(request);
    }
    return next.handle(request);
  }
}
